import { coursesApi } from './courses-base.api';
import type {
	GetAdminUserProfileInput,
	GetAdminUserProfileOutput,
	GetAdminUserAnalyticsInput,
	GetAdminUserAnalyticsOutput,
} from '../../types/admin-user-profile.types';

const TAG = 'courses:admin-user-profile' as const;

export const adminUserProfileEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		getAdminUserProfile: builder.query<GetAdminUserProfileOutput, GetAdminUserProfileInput>({
			query: ({ userId }) => ({ url: `courses/admin/users/${encodeURIComponent(userId)}/profile` }),
			providesTags: [TAG],
		}),
		getAdminUserAnalytics: builder.query<GetAdminUserAnalyticsOutput, GetAdminUserAnalyticsInput>({
			query: ({ userId }) => ({
				url: `courses/admin/users/${encodeURIComponent(userId)}/analytics`,
			}),
			providesTags: [TAG],
		}),
	}),
});

export const {
	useGetAdminUserProfileQuery,
	useLazyGetAdminUserProfileQuery,
	useGetAdminUserAnalyticsQuery,
	useLazyGetAdminUserAnalyticsQuery,
} = adminUserProfileEndpoints;
